exports.generate = function (limit,isHaveNumber = true){
    var allKey = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
	if (isHaveNumber) {
		allKey = allKey + "0123456789"
    }
    const len = allKey.length
    var res = ""
    for (let index = 0; index < limit; index++) {
        var randomNumber = Math.floor(Math.random() * len)
        res += allKey.substring(randomNumber, randomNumber+1);
    }
    return res;
}